/**
 * @fileoverview Drawer Arc onde o ALUNO submete as entregas (deliverables) de uma
 * LIÇÃO. Espelha o `StudentDeliverableSubmitDrawer` do protótipo: header "Submit
 * deliverable" e uma seção por atividade com deliverable. Padrão `LumiarDrawer`,
 * arc only, aditivo (não toca legado/professor).
 */

import { Box, Group, Stack, Text, Title } from '@mantine/core'
import { IconX } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import LumiarDrawer from 'components/LumiarDrawer/LumiarDrawer'
import { StudentDeliverableSection } from './StudentDeliverableSection'

const DRAWER_WIDTH = 700

interface StudentDeliverableDrawerProps {
  opened: boolean
  activityIds: string[]
  onClose: () => void
}

export function StudentDeliverableDrawer({ opened, activityIds, onClose }: StudentDeliverableDrawerProps) {
  const { t } = useTranslation()

  return (
    <LumiarDrawer visibility={opened} onChange={(v: boolean) => !v && onClose()} side="right">
      <Box style={{ width: DRAWER_WIDTH, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Group position="apart" align="center" p="md" noWrap>
          <Title order={3}>{t('task_tracker.deliverable_drawer.submit_title')}</Title>
          <IconX size={20} style={{ cursor: 'pointer', flexShrink: 0 }} onClick={onClose} />
        </Group>

        <Box px="md" pb="md" style={{ flex: 1 }}>
          {activityIds.length === 0 ? (
            <Text color="dimmed" size="sm">{t('task_tracker.deliverable_drawer.not_submitted_yet')}</Text>
          ) : (
            <Stack spacing="lg">
              {activityIds.map((id, index) => (
                <StudentDeliverableSection
                  key={id}
                  activityId={id}
                  opened={opened}
                  showHeader={index === 0}
                  withDivider={index > 0}
                  onSubmitted={onClose}
                />
              ))}
            </Stack>
          )}
        </Box>
      </Box>
    </LumiarDrawer>
  )
}
